export default __webpack_public_path__ + "static/media/Amelia-Trustee.a9fe622e.jpg";